/* import __COLOCATED_TEMPLATE__ from './resolve-a-conversation.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();